import i18next, { TFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Locale } from 'ggApp/types/common';

import i18nextBackend from './i18nextBackend';
import i18nextLanguageDetector from './i18nextLanguageDetector';
import { Namespace } from './types';

function initLocalization(): Promise<TFunction> {
    return i18next
        .use(i18nextLanguageDetector)
        .use(i18nextBackend)
        .use(initReactI18next)
        .init({
            ns: [Namespace.translations, Namespace.translator],
            defaultNS: Namespace.translations,
            fallbackLng: Locale.en,
            supportedLngs: Object.values(Locale),
            interpolation: {
                escapeValue: false,
            },
            compatibilityJSON: 'v3',
        });
}

export default initLocalization;
